module.exports = __webpack_public_path__ + "media/PAG58-04.60ebd9ae.mp3";